/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { paginatedSocialProfileSuggestionsResponseDtoSchema } from "../paginatedSocialProfileSuggestionsResponseDtoSchema";
import { z } from "zod/v4";

export const listSuggestionsQueryParamsSchema = z.object({
    "pageNumber": z.coerce.number().min(1).default(1),
"pageSize": z.coerce.number().min(1).max(100).default(25),
"status": z.optional(z.enum(["auto_accepted", "pending", "accepted", "rejected", "discarded"]).describe("Filter by status — 'pending' lists the suggestions waiting for review, and the response's `total` is their count")),
"contactId": z.optional(z.uuid())
    })

export const listSuggestionsHeaderParamsSchema = z.object({
    "x-tenant-id": z.optional(z.string().describe("Required tenant context header for tenant-scoped endpoints guarded by ApiGuard."))
    }).optional()

/**
 * @description Social profile suggestions from automatic enrichment, newest first. Use status=pending for the review list — `total` is then the number waiting for review.
 */
export const listSuggestions200Schema = z.lazy(() => paginatedSocialProfileSuggestionsResponseDtoSchema)

/**
 * @description Missing tenant context or invalid x-api-key header for guarded endpoints.
 */
export const listSuggestions401Schema = z.any()

export const listSuggestionsQueryResponseSchema = z.lazy(() => listSuggestions200Schema)